import {KpiCardData} from '../models/kpi-card-data.model';
import {formatCurrencyFromCents, formatNumber} from './format.util';

export interface KpiApiResponse {
  title: string;
  value: number;
  comparisonPercent: number;
  showComparison: boolean;
  icon: string;
  iconColor?: string;
  svgColor?: string;
}

export function formatKpiValue(
  value: number,
  format: 'currency' | 'number' | 'percentage' = 'number'
): string {
  switch (format) {
    case 'currency':
      return formatCurrencyFromCents(value);
    case 'percentage':
      return `${value.toFixed(1)}%`;
    case 'number':
    default:
      return formatNumber(value);
  }
}

export function calculateComparison(
  comparisonPercent: number,
  showComparison: boolean,
  // The localized "from last month" suffix. Kept as a parameter so this pure
  // util stays free of the translation service; the caller passes the string.
  comparisonSuffix = 'from last month',
): {text: string; isPositive: boolean} {
  if (!showComparison || comparisonPercent === 0) {
    return { text: '\u00A0', isPositive: true };
  }
  const sign = comparisonPercent >= 0 ? '+' : '';

  return {
    text: `${sign}${comparisonPercent.toFixed(1)}% ${comparisonSuffix}`,
    isPositive: comparisonPercent >= 0
  };
}

export function mapApiResponseToKpiCard(
  apiData: KpiApiResponse,
  format: 'currency' | 'number' | 'percentage' = 'number',
  comparisonSuffix = 'from last month'
): KpiCardData {
  const comparison = calculateComparison(
    apiData.comparisonPercent,
    apiData.showComparison,
    comparisonSuffix
  );
  return {
    title: apiData.title,
    value: formatKpiValue(apiData.value, format),
    comparison: comparison.text,
    icon: apiData.icon,
    iconColor: apiData.iconColor,
    svgColor: apiData.svgColor,
    isPositive: comparison.isPositive
  };
}

